<script>
export default {
  methods: {
    getPrices(items, calc = false) {
      this.$emit('loading', true)
      this.$api
        .get('calculator/get_prices', {
          params: {
            year: this.year,
            name: items,
          },
        })
        .then((res) => {
          this.pricelist = res.data
          if (calc) {
            this.calc()
          }
          this.$emit('loading', false)
        })
    },
  },
}
</script>
